import { Outlet } from "react-router-dom";
import TopBar from "@/components/shell/top-bar";
import TabBar from "@/components/shell/tab-bar";
import Footer from "@/components/shell/footer";

/**
 * App shell for list routes (/home, /grids, /wind, /backtest).
 * Renders: top bar → tab bar → page outlet → footer.
 * Summary stats + charts live in HomePage; list pages render their own content.
 */
export default function AppLayout() {
  return (
    <div className="min-h-screen bg-bg">
      <TopBar />
      <TabBar />
      <main className="px-4 py-4 pb-6">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
